import { TextStencilEditor } from "./TextStencilEditor";

/**
 * Specialized stencil editor for image stencils.
 * 
 * @see {@link core!ImageStencil}
 */
export class ImageStencilEditor extends TextStencilEditor {
}
